<main>
  <article #fs fullscreen-able [class.is-active]="isActive" style="background-color: #fff">
    <div class="widget-container" #paymentHGridDiv id="gridViewscrollbar">
      
      <div class="mb-1" [style.padding]="this.isIcon ? '' : '10px 0'">
        <icon-chart 
          [headerConfig]="headerConfig" 
          [iconList]="iconList" 
          [data]="rowData" 
          [pageKey]="pageKey"
          [selectedHeader]="selectedHeader"
          [heading]="heading" 
          [chartName]="'PaymentGrid'" 
          [config]="paymentHGridDiv" 
          [expand]="fs"
          [apiKey]="this.item.config?.['list_of_api_parent']?.api_key"
          [fullscreen]="isFullscreen" 
          [item]="item" 
          (exportToPdf)="exportToPdf($event)"
          (typeToSearch)="onQuickFilterChanged($event)"
          (screenChanges)="screenChanges($event)"
          (changeDisplays)="changeDisplays($event)"
          (expendCol)="expendCol($event)">
        </icon-chart>
      </div>

      <div style="height: 230px; width: auto;" *ngIf="loader">
        <loading></loading>
      </div>

      <div style="height: 230px; width: auto; " *ngIf="!loader && rowData.length==0">
        <span class="bg-text"> {{ error_name ? error_name : 'There is no data for this time period' }} </span>
      </div>

      
      <!-- <button style="font-size: 12px" (click)="onBtStartEditing()">
        Start Editing Line 2
      </button> -->
      <div id="pdfAgTable" #pdfTable>
        <ag-grid-angular 
          #paymentGrid 
          [style.display]="(rowData.length==0 || error_name) ? 'none' : 'block'"
          [style.height]="(this.item.config?.['fixed_height'] && !isFullscreen) ? this.item.config?.['fixed_height']+'px' :'100%'"
          [style.margin-bottom]="this.item.config?.['fixed_height'] ? '0px' :'15px'"
          style="width: 100%; height: 100%;"
          class="ag-theme-alpine test recordErrorPaymentHira" 
          [class.recordErrorSideBarNot]="isPivotGrid"
          [class.dividerVisibility]="!dividerVisibility"
          [class.recordErrorSideBar]="!isPivotGrid"
          [class]="rowGroupingDisplayIcon"
          [class.gridRowColor]="gridRowColor"
          [sideBar]="isPivotGrid ? sideBar : false"
          [class.paginationBottom]="pagination"
          [suppressDragLeaveHidesColumns]="true"
          [columnDefs]="columnDefs" 
          [defaultColDef]="defaultColDef"
          [animateRows]="true"
          [excelStyles]="excelStyles"
          [masterDetail]="isDetailGrid" 
          [detailRowAutoHeight]="detailRowAutoHeight" 
          [suppressAggFuncInHeader]="true"
          [groupRowRendererParams]="groupRowRendererParams"
          [rowHeight]="minRowHeight" 
          [autoGroupColumnDef]="autoGroupColumnDef"
          [detailCellRendererParams]="detailCellRendererParams" 
          [detailRowHeight]="350"
          [frameworkComponents]="connectingCustomDetail ? frameworkComponents : false"
          [detailCellRenderer]="detailComponent ? detailComponent :'basicLineChartGridRenderer'"
          refreshStrategy="everything" 
          [suppressRowTransform]="true" 
          [pagination]="pagination"
          [paginationPageSize]="pageSizeCount"
          (sortChanged)="onSortChanged($event)"
          [rowData]="rowData"
          [pinnedBottomRowData]="(this.item.config?.['grand_total']?.value == 'yes')?[grandTotalRow]:undefined"
          [suppressFooterTotal]="false"
          [suppressContextMenu]="!contextMenuCondition"
          [groupDisplayType]="groupDisplayType"
          [gridOptions]="gridOptions"
          [isGroupOpenByDefault]="isGroupOpenByDefault"
          [aggFuncs]="aggFuncs"
          (gridReady)="onGridReady($event)">
        </ag-grid-angular>
      </div>
    </div>
  </article>
</main>

<!-- For Pdf -->
<ng-template #pdfSettingGrid>
  <app-pdf-export-popup 
    *ngIf="!loader"
    [paymentGridData]="paymentGrid" 
    [columnDefs]="pdfColumnDefs"
    [columnDefs2]="childColumnDefs" 
    [rowData]="rowData" 
    [groupData]="GroupedData"
    [table]="pdfTable">
  </app-pdf-export-popup>
</ng-template>